import { Component } from "@angular/core";
import { DilemaService } from "./dilema.service";

@Component({
  selector: "dilema-game",
  templateUrl: "./dilema-game.component.html",
  styleUrls: ["./dilema-game.component.css"]
})
export class DilemaGameComponent {
  title = "Dilemma Spil";
  dilemmas;
  selectedDilemma;
  searchDilemma(dilemmaId) {
    for (let dilemma of this.dilemmas) {
      if (dilemma.id == dilemmaId) this.selectedDilemma = dilemma;
    }
  }

  constructor(dilemmaService: DilemaService) {
    this.dilemmas = dilemmaService.getDilemmas();
    this.searchDilemma(1);
  }

  items: [
    { bgcolor: "#fb9667"; img: "airTicket"; category: "Air tickets" },
    { bgcolor: "#000000"; img: "airTicket"; category: "Beauty/Fitness" },
    { bgcolor: "#0b9660"; img: "airTicket"; category: "Bike" }
  ];
}
